/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscriptions_Tab_MonthInputs */

const en_admin_subscriptions_tab_month = /** @type {(inputs: Admin_Subscriptions_Tab_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly`)
};

const zh_admin_subscriptions_tab_month = /** @type {(inputs: Admin_Subscriptions_Tab_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月付`)
};

/**
* | output |
* | --- |
* | "Monthly" |
*
* @param {Admin_Subscriptions_Tab_MonthInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_subscriptions_tab_month = /** @type {((inputs?: Admin_Subscriptions_Tab_MonthInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscriptions_Tab_MonthInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_subscriptions_tab_month(inputs)
	return zh_admin_subscriptions_tab_month(inputs)
});
export { admin_subscriptions_tab_month as "admin.subscriptions.tab_month" }